import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-footer-hifpt',
  templateUrl: './footer-hifpt.component.html',
  styleUrls: ['./footer-hifpt.component.scss']
})
export class FooterHifptComponent {

  constructor() { }

}
